module Meevo.Plugins.Register {
    "use strict";
    export enum ProductSelectionMode {
        Product = 0,
        Recommended = 1,
        Bundle = 2,
        Cats = 3,
        Shop = 4,
        CustomBundleConfiguration = 5
    }
    export class ProductsSection extends Meevo.Plugins.Register.RegisterSectionBase {
        public tileListView: boolean = true;
        products: any;
        productCats: any;
        selectedProductCat: any;
        selectedManufacturer: any;
        filter: string = "";
        minProductFilterLength: number = 2;
        scannedTransactionId: string = "";
        selectionMode: ProductSelectionMode = ProductSelectionMode.Cats;
        showRefundType: Meevo.Plugins.Register.RefundTypes = Meevo.Plugins.Register.RefundTypes.History;
        client: Model.ClientListItem = null;
        transactionSaleLines: any;
        transactionRequest: any = {
            pageNumber: 0,
            itemsPerPage: 25,
            sortDirection: "Descending",
            criteria: {
                saleType: Model.SalesTypeEnum.Product,
                clientId: !!this.client ? this.client.id : null,
                includeAllLocations: true,
                includeAuthorizationPaymentRequest: true,
            }
        };
        
        prevSelectionMode: ProductSelectionMode = ProductSelectionMode.Cats;

        ProductRecommendation: any;
        ProductBundle: any;
        CustomProductBundle: any;
        ShopSupply: any;
        isResellByDefault: boolean = false;
        selectProductRecommendationsFlag: boolean = false;
        saleLine: Model.SaleLine;
        productBundle;
        productBundleProduct;
        isAwaitingProductListWithAutoSelect: boolean = false;
        cachedProductListRequest: any;

        get $rootScope() { return this.registerContext.$rootScope; }
        get $filter() { return this.registerContext.$filter; }
        get $translate() { return this.registerContext.$translate; }
        get $q() { return this.registerContext.$q; }

        get endPoints() { return this.registerContext.appSettings.API_ENDPOINTS; }
        get dataService() { return this.registerContext.dataService; }
        get modalService() { return this.registerContext.modalService; }

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.Products, registerContext, "products", Register.RegisterSectionCatTypeEnum.Sale);

            this.ProductRecommendation = {
                id: Guid.empty.toString(),
                displayName: this.$translate.instant("LABEL_PRODUCT_RECOMMENDATION"),
                isRecommended: true
            };
    
            this.ProductBundle = {
                id: Guid.empty.toString(),
                displayName: this.$translate.instant("LABEL_PRODUCT_BUNDLES"),
                isBundle: true,
                isCustomBundle: false
            };

            this.CustomProductBundle = {
                id: Guid.empty.toString(),
                displayName: this.$translate.instant("LABEL_CUSTOM_PRODUCT_BUNDLES"),
                isBundle: true,
                isCustomBundle: true
            }

            this.ShopSupply = {
                id: Guid.empty.toString(),
                displayName: this.$translate.instant("LABEL_SHOP_SUPPLIES"),
                isShopSupply: true,
                securityKey: Components.Common.SecurityKeys.REGISTER_REGISTER_PRODUCTS_SELLRETAILPRODUCTS_SELLSHOPSUPPLIES + Components.Common.SecurityParts.KEY_PART_READ
            };
        }

        toggleView = () => {
            this.tileListView = !this.tileListView;
        }

        getProductCats(inventoryTypeEnum: Model.ProductInventoryTypeEnum = Model.ProductInventoryTypeEnum.Retail): void {
            
            let request = {
                pageNumber: 0,
                itemsPerPage: 1000,
                sortDirection: Model.SortDirection.Ascending,
                manufacturerId: (this.selectedManufacturer) ? this.selectedManufacturer.id : null,
                onlyWithProducts: true,
                productInventoryTypes: [inventoryTypeEnum, Model.ProductInventoryTypeEnum.RetailOrShopSupply],
            }

            var defer = this.$q.defer();
            this.dataService.getListPaged(this.endPoints.productcategories, request).then((response: any) => {
                this.productCats = response;
                
                if (this.selectionMode !== ProductSelectionMode.Shop
                    && inventoryTypeEnum !== Model.ProductInventoryTypeEnum.ShopSupply) {

                    this.productCats.unshift(this.ShopSupply);
                    if (!this.registerContext.isRefundMode) {
                        this.productCats.unshift(this.CustomProductBundle);
                        this.productCats.unshift(this.ProductBundle);
                        this.productCats.unshift(this.ProductRecommendation);
                    }
                }

                if (this.selectProductRecommendationsFlag) {
                    this.selectProductRecommendationsFlag = false;
                    this.selectProductRecommendations();
                }
            });
        }

        getProducts(includeBundles, includeProducts, autoSelectOnOne: boolean = false, productCatId = undefined) {
            let filter = this.filter.trim().length >= this.minProductFilterLength ? this.filter : "";
            let productInventoryTypeEnum = this.selectedProductCat && this.selectedProductCat.isShopSupply
                ? Model.ProductInventoryTypeEnum.ShopSupply
                : Model.ProductInventoryTypeEnum.Retail;

            let request = {
                pageNumber: 0,
                itemsPerPage: 1000,
                sortDirection: Model.SortDirection.Ascending,
                criteria: {
                    productCategoryId: productCatId,
                    filter: filter,
                    //barCode: this.filter.trim().length >= this.minProductFilterLength ? this.filter : "",
                    //sku: this.filter.trim().length >= this.minProductFilterLength ? this.filter : "",
                    manufacturerId: (this.selectedManufacturer) ? this.selectedManufacturer.id : null,
                    includeBundles: includeBundles,
                    includeProducts: includeProducts,
                    variantObjectState: [Model.ObjectStateEnum.Active, Model.ObjectStateEnum.Inactive],
                    wildcardType: Model.FilterWildcardType.Contains,
                    explicitProductInventoryTypes: [productInventoryTypeEnum, Model.ProductInventoryTypeEnum.RetailOrShopSupply],
                    isCustomBundle: null
                }
            }

            var getProductList = (request, autoSelect) => {
                this.isAwaitingProductListWithAutoSelect = this.isAwaitingProductListWithAutoSelect || autoSelect;
                this.dataService.getListPaged("productVariant", request).then((response: any) => {
                    if (this.cachedProductListRequest && autoSelect) {
                        var req = Object.assign({}, this.cachedProductListRequest);
                        this.cachedProductListRequest = undefined;
                        getProductList(req, true);
                        return;
                    }

                    if (response.length == 1) {
                        var singleProductResult = response[0];
                        if (singleProductResult.notForSale) {
                            // show error message
                            this.modalService.alert("MESSAGE_PRODUCT_NOT_FOR_SALE", Components.Modal.ModalTranslationModes.Translate).finally(() => defer.resolve());
                        }
                        else if (autoSelect) {
                            // Add single result item to ticket
                            this.add(singleProductResult);
                            defer.reject();
                        }
                    }

                    this.products = _(response).filter((item: any) => !item.notForSale);
                    _(this.products).each((product: any) => product.isResell = this.isResellByDefault);
                    this.getProductPrices().finally(() => {
                        if (autoSelect) {
                            this.isAwaitingProductListWithAutoSelect = false;
                        }
                        defer.resolve();
                    });
                });
            }

            var defer = this.$q.defer();
            if (autoSelectOnOne && this.isAwaitingProductListWithAutoSelect) {
                this.cachedProductListRequest = request;
                defer.reject();
            } else {
                getProductList(request, autoSelectOnOne);
            }
            return defer.promise;
        }

        getProductRecommendations(): ng.IPromise<number> {
            if (this.registerContext.selectedClient && this.registerContext.selectedClient.id) {
                let request = {
                    pageNumber: 0,
                    itemsPerPage: 1000,
                    sortDirection: Model.SortDirection.Ascending,
                    criteria: {
                        clientId: this.registerContext.selectedClient.id
                    }
                }

                return this.dataService.getListPaged("productRecommendation", request).then((response: any) =>
                {
                    this.products = _.filter(response, function(item: any) { return !item.notForSale; });
                    return this.products.length;
                });
            } else {
                return this.$q.resolve(0);
            }
        }

        getProductPrices() {
            let request = {
                applyAutomaticDiscounts: false,
                applyMemberDiscounts: false,
                applySalePrograms: true,
                calculateTax: false,
                products: _.map(this.products, (item: any) => {
                    return { productId: item.productId, variantId: item.id, retail: item.retail };
                })
            }
            return this.dataService.customMethodData("api/Product/RegisterPrice/List", "POST", request)
                .then((response: any) => {
                    let productPrices: any[] = response.data.products;
                    var sortFn = (a, b) => { return (a.priceRequest.variantId > b.priceRequest.variantId) ? 1 : ((a.priceRequest.variantId < b.priceRequest.variantId) ? -1 : 0) };
                    productPrices.sort(sortFn);
                    let loadedProducts = _.map(this.products, (item: any) => {
                        return { priceRequest: { variantId: item.id }, item: item };
                    })
                    loadedProducts.sort(sortFn);
                    for (var loadedNdx = 0, priceNdx = 0, loadedLen = loadedProducts.length, priceLen = productPrices.length; loadedNdx < loadedLen && priceNdx < priceLen;) {
                        if (loadedProducts[loadedNdx].priceRequest.variantId < productPrices[priceNdx].priceRequest.variantId) {
                            loadedNdx++;
                        }
                        else if (loadedProducts[loadedNdx].priceRequest.variantId > productPrices[priceNdx].priceRequest.variantId) {
                            priceNdx++;
                        }
                        else { // if (loadedServices[loadedNdx].priceRequest.serviceId == servicePrices[priceNdx].priceRequest.serviceId)
                            loadedProducts[loadedNdx].item.salePrice = productPrices[priceNdx].finalPrice;
                            loadedNdx++;
                            priceNdx++;
                        }
                    }
                });
        }

        selectProductCat(productCat) {
            this.selectedProductCat = productCat;
            if (this.selectedProductCat.isRecommended) {
                this.selectionMode = ProductSelectionMode.Recommended;
                this.getProductRecommendations();
            } else if (this.selectedProductCat.isBundle) {
                this.getProducts(true, false, false, undefined).then(() => {
                    this.products = _(this.products).where({ isCustomProductBundle: this.selectedProductCat.isCustomBundle})
                    this.selectionMode = ProductSelectionMode.Bundle;
                });
            } else if (productCat.isShopSupply && this.selectionMode !== ProductSelectionMode.Shop) {
                this.selectionMode = ProductSelectionMode.Shop;
                this.productCats = undefined;
                this.getProductCats(Model.ProductInventoryTypeEnum.ShopSupply);
            } else if (this.selectionMode === ProductSelectionMode.Shop) {
                this.selectionMode = ProductSelectionMode.Product;
                this.selectedProductCat.isShopSupply = true;
                this.selectedProductCat.prefix = this.ShopSupply.displayName;
                this.getProducts(false, true, false, productCat.id);
            } else {
                this.getProducts(false, true, false, productCat.id).then(() => {
                    this.selectionMode = ProductSelectionMode.Product;
                });
            }
        }

        selectProductRecommendations()
        {
            let recommendedCat = _(this.productCats).findWhere({ isRecommended: true });
            if (recommendedCat) {
                this.selectProductCat(recommendedCat);
            } else {
                this.selectProductRecommendationsFlag = true;
            }
        }
        
        getProductClass(product) {
            if (product.isOnHandBelowOrderPoint) {
                return "color-red";
            }
        }

        addProductBundleProduct() {
            if (!this.productBundleProduct) {
                return;
            }

            let messageKey;
            let matchingProductGroup = this.findProductGroupInBundle(this.productBundleProduct.id);
            if (!matchingProductGroup) {
                messageKey = "MESSAGE_REGISTER_PRODUCT_NOT_FOUND_IN_BUNDLE";
            }
            else if (!this.bundleGroupHasNecessaryQuantity(matchingProductGroup.group)) {
                matchingProductGroup.product.quantity++;
            }
            else {
                messageKey = "MESSAGE_REGISTER_BUNDLE_QUANTITY_LIMIT_ADD";
            }
            
            if (messageKey) {
                this.showProductBundleAlert(this.productBundleProduct.displayName,
                    this.productBundleProduct.variantDisplayName, this.productBundleProduct.sku, messageKey);
            }
            this.productBundleProduct = undefined;  
        }

        showProductBundleAlert(displayName, variantDisplayName, sku, messageKey) {
            this.modalService.alert(this.$translate.instant(messageKey,
                {
                    sku: sku,
                    displayName: displayName,
                    variantDisplayName: variantDisplayName ?
                        `- ${variantDisplayName} ` : ""
                }), Components.Modal.ModalTranslationModes.DoNotTranslate);
        }

        edit(saleLine: Model.SaleLine) {
            this.registerContext.hideCheckoutButtons = true;
            let productItem = <CustomProductBundleSaleLineItem>saleLine.item;
            this.productBundle = productItem.productBundle;
            this.saleLine = saleLine;
            this.selectionMode = ProductSelectionMode.CustomBundleConfiguration;
        }

        findProductGroupInBundle(id) {
            for (let group of this.productBundle.customBundleGroups) {
                let product = _(group.customProductVariantBundles).findWhere({ id: id });
                if (product) {
                    return { product, group };
                }
            }
        }

        bundleProductQuantityChange(product, group) {
            let groupQuantity = this.getBundleGroupQuantity(group)
            if (groupQuantity > group.requiredQuantity) {
                product.quantity -= (groupQuantity - group.requiredQuantity)
                this.showProductBundleAlert(product.productDisplayName, product.variantDisplayName, product.sku, "MESSAGE_REGISTER_BUNDLE_QUANTITY_LIMIT_INCREASE");
            }
        }

        getBundleGroupQuantity(group) {
            return _(group.customProductVariantBundles).chain().pluck("quantity").reduce((total, current) => total += current, 0).value();
        }

        bundleGroupHasNecessaryQuantity(group) {
            return (this.getBundleGroupQuantity(group) >= group.requiredQuantity)
        }

        addCustomBundle() {
            if (_(this.productBundle.customBundleGroups).any(group => !this.bundleGroupHasNecessaryQuantity(group))) {
                return;
            }
            (<CustomProductBundleSaleLineItem>this.saleLine.item).productBundle =
                this.productBundle;
            this.addSaleLine();
        }

        add(product) {
            this.selectedProductCat = _(this.productCats).find(cat => cat.id === product.categoryId);

            let saleLine: Model.SaleLine = {
                quantity: 1,
                basePrice: product.retail,
                finalPrice: product.retail,
                baseItemPrice: product.retail,
                finalItemPrice: product.retail,
                client: this.registerContext.selectedClient,
                clientId: this.registerContext.selectedClient ? this.registerContext.selectedClient.id : undefined,
                clientType: this.registerContext.selectedClientType,
                appointmentId: this.registerContext.selectedClientAppointmentId,
                saleType: Model.SalesTypeEnum.Product,
                isNew: (this.registerContext.selectedClientType == Model.ClientTypeEnum.Client),
                isRefund: this.registerContext.isRefundMode,
                isDirty: true,
                showPoleMessage: Model.SaleLineStatusEnum.Added
            };

            let productItem = {
                displayName: product.displayName,
                id: product.id,
                sku: product.sku,
                barCode: product.barCode,
                productId: product.productId,
                variantAttributes: product.variantAttributes,
                isProductBundle: product.isProductBundle,
                isResell: (this.registerContext.isRefundMode) ? this.isResellByDefault : null,
                productInventoryType: product.productInventoryType == Model.ProductInventoryTypeEnum.RetailOrShopSupply
                    ? this.selectedProductCat.isShopSupply
                        ? Model.ProductInventoryTypeEnum.ShopSupply
                        : Model.ProductInventoryTypeEnum.Retail
                    : product.productInventoryType,
                isLotTracked: product.trackLots
            }
            this.saleLine = saleLine;
            if (product.isCustomProductBundle) {
                this.dataService.customMethodData(`/api/ProductBundles/${product.productId}?includeStockLevel=true`, "get", {}).then(response => {
                    this.productBundle = response.data;
                    saleLine.item = new Meevo.Plugins.Register.CustomProductBundleSaleLineItem(productItem)
                    this.selectionMode = ProductSelectionMode.CustomBundleConfiguration;
                    this.registerContext.hideCheckoutButtons = true;
                })
            }
            else {
                saleLine.item = new Meevo.Plugins.Register.ProductSaleLineItem(productItem);
                if (product.trackLots) {
                    this.registerContext.addLotAllocation(saleLine);
                }
                this.addSaleLine();
            }
        }

        addSaleLine() {
            
            if (this.saleLine.id) {
                this.registerContext.recalculateSale()
                    .then(() => {
                        this.reset();
                    });
            }
            else if (!this.registerContext.isRefundMode && this.registerContext.selectedEmployee && !this.registerContext.requireEmployeeSelectionForRetail &&
                this.registerContext.selectedEmployee.allowSales && (this.registerContext.selectedEmployee.employeeEntityType !== Model.EmployeeEntityTypeEnum.Student ||
                    (this.registerContext.selectedTeacher && this.registerContext.selectedTeacher.id !== Meevo.Guid.empty.toString()))) {
                this.saleLine.employeeId = this.registerContext.selectedEmployee.id;
                this.saleLine.employee = this.registerContext.selectedEmployee;
                if (this.registerContext.selectedEmployee.employeeEntityType === Model.EmployeeEntityTypeEnum.Student &&
                    this.registerContext.selectedTeacher &&
                    this.registerContext.selectedTeacher.id !== Meevo.Guid.empty.toString()) {
                        
                    this.saleLine.teacher = this.registerContext.selectedTeacher;
                    this.saleLine.teacherId = this.registerContext.selectedTeacher.id;
                }
                this.registerContext.sale.saleLines.push(this.saleLine);
                this.registerContext.recalculateSale();
                this.localReset();
                this.registerContext.displayNotification(false)
            }
            else {
                this.registerContext.tempSaleLines = [this.saleLine];
                if (this.registerContext.isRefundMode && (<any>this.saleLine.item).isLotTracked && this.registerContext.hasClient()) {
                    // Lot-tracked refund (named or anonymous client) captures the lot first; the lot
                    // screen's Next then runs the (lot-keyed) historical match check.
                    this.registerContext.selectSection(RegisterSectionTypeEnum.LotSelection);
                }
                else if (this.registerContext.selectedClient && this.registerContext.isRefundMode) {
                    // Non-lot refund for a named client: run the client-keyed historical match check.
                    this.addRefundSaleLine(this.saleLine.item.id, Model.SalesTypeEnum.Product, () => this.localReset());
                }
                else {
                    // Non-refund, or an anonymous non-lot refund (no client history to search): go to employee.
                    this.registerContext.selectSection(RegisterSectionTypeEnum.Employee);
                }
            }
        }

        reset(isSelection: boolean = false) {
            if (!this.registerContext.isRefundMode && !this.registerContext.sellProductPermission) {
                this.registerContext.showEmptySection();
            }

            // continueExecution() resets this section twice coming back from employee selection: once
            // with prev=Products (which loads the refund history) and again via selectSection with
            // prev=Employee. The second localReset() would wipe the loaded history without reloading it
            // (the reload below is gated on prev != Employee). Preserve it instead of paying for a
            // second load.
            const returningFromEmployee = this.registerContext.previouslySelectedSection.sectionType === RegisterSectionTypeEnum.Employee;
            const preservedHistory = (returningFromEmployee
                && this.registerContext.isRefundMode
                && this.showRefundType === Meevo.Plugins.Register.RefundTypes.History)
                ? this.transactionSaleLines
                : null;

            if (this.selectionMode != ProductSelectionMode.Recommended || isSelection) {
                this.localReset();
            }

            if (preservedHistory) {
                this.transactionSaleLines = preservedHistory;
            }

            if (!returningFromEmployee) {
                this.showRefundType = Meevo.Plugins.Register.RefundTypes.History;
                if (this.registerContext.selectedClientType == Model.ClientTypeEnum.Client) {
                    this.client = this.registerContext.selectedClient;
					if (this.registerContext.isRefundMode) {
						this.getProductSaleLineHistory();
                        this.isResellByDefault = this.registerContext.allowProductRefundingResell;
					}
                }
            }
        }

        localReset() {
            this.getProductCats();
            this.filter = "";
            this.selectionMode = ProductSelectionMode.Cats;
            this.selectedProductCat = undefined;
            this.products = undefined;
            this.client = null;
            this.transactionRequest.criteria.clientId = null;
            this.saleLine = undefined;
            
			if (this.registerContext.isRefundMode) {
				this.transactionSaleLines = new Components.BaseClasses.PagedResults<Model.SaleLine, any>(this.dataService, "saleLine", this.onPageLoad);
				this.transactionSaleLines.clearSearch();
			}
			else {
                this.transactionSaleLines = null;
                this.registerContext.hideCheckoutButtons = false;
			}

            this.refundSubTotal = 0;
            this.refundTax = 0;
            this.scannedTransactionId = "";
        }



        filterChange() {
            this.getProductsDebounce(true);
        }
        manufacturerChange() {
            this.getProductsDebounce();
        }

        getProductsDebounce = _.debounce((autoSelectOnOne: boolean = false) => {
            this.$rootScope.$apply(() => {
                if (this.filter.trim().length >= this.minProductFilterLength || this.selectedManufacturer || (this.selectedProductCat && !this.selectedProductCat.isShopSupply)) {
                    this.getProducts(true, true, autoSelectOnOne).then(() => {
                        this.selectionMode = ProductSelectionMode.Product;
                    });
                } else {
                    this.getProductCats();
                    this.selectionMode = ProductSelectionMode.Cats;
                }
            });
        }, 300);

        onPageLoad = (pageNumber, items) => {
            for (var i = 0, len = items.length; i < len; i++) {
                let item = items[i];
                let matchedSaleLine = _.findWhere(this.registerContext.sale.saleLines, { refundTransactionId: item.transactionId, refundSaleLineId: item.id, isRefund: true, refundLocationId: item.locationId });
                if (matchedSaleLine && !item.isRefund) {
                    item.isRefund = true;
                    item.item.isResell = (matchedSaleLine.item as ProductSaleLineItem).isResell;
                    this.refundSubTotal += this.getRefundPrice(matchedSaleLine, matchedSaleLine.newQuantity);
                    this.refundTax += this.getRefundTax(matchedSaleLine, matchedSaleLine.quantity);
                    item.newQuantity = matchedSaleLine.quantity;
                    item.lastNewQuantity = matchedSaleLine.quantity;
                }
                else {
                    item.newQuantity = item.quantity;
                    item.lastNewQuantity = item.quantity;
                    item.item.isResell = !!this.registerContext.allowProductRefundingResell;
                }
            }
        }

        getProductSaleLineHistory() {
            this.transactionRequest.criteria.clientId = !!this.client ? this.client.id : null;
            // initSearch holds the request by reference and reads it at fetch time, so pass a copy —
            // a later localReset() that nulls transactionRequest.criteria.clientId must not corrupt
            // this in-flight search (which is what blanked the refund history on the way back from
            // employee selection).
            this.transactionSaleLines.initSearch(angular.copy(this.transactionRequest));
            this.refundSubTotal = 0;
            this.refundTax = 0;
        }

        refundItemClicked(saleLine: Model.SaleLine, isChecked: boolean) {
            if (isChecked) {
                if (this.registerContext.isMismatch(this.registerContext.getAuthorizationPaymentRequestId(this.registerContext.sale), saleLine.authorizationPaymentRequestId) ||
                    this.hasAuthorizationPaymentRequestIdMismatch(_(this.transactionSaleLines.loadedPages).flatten().filter(line => line.isRefund))
                ) {
                    this.registerContext.displayRefundMismatchMessage(false, true);
                    saleLine.isRefund = false;
                    return;
                }

                var props = { transactionId: saleLine.transactionId, saleLineId: saleLine.id, isRefund: true, locationId: saleLine.locationId };
                (saleLine.item as ProductSaleLineItem).isResell = !!this.registerContext.allowProductRefundingResell;
                this.refundSubTotal += this.getRefundPrice(saleLine, saleLine.newQuantity);
                this.refundTax += this.getRefundTax(saleLine, saleLine.newQuantity);
            }
            else {
                var refundProps = { refundTransactionId: saleLine.transactionId, refundSaleLineId: saleLine.id, isRefund: true, refundLocationId: saleLine.locationId };
                let matchedSaleLine = _.findWhere(this.registerContext.sale.saleLines, refundProps);
                if (matchedSaleLine) {
                    this.refundSubTotal -= this.getRefundPrice(matchedSaleLine, matchedSaleLine.newQuantity);
                    this.refundTax -= this.getRefundTax(matchedSaleLine, matchedSaleLine.newQuantity);
                } else {
                    this.refundSubTotal -= this.getRefundPrice(saleLine, saleLine.newQuantity);
                    this.refundTax -= this.getRefundTax(saleLine, saleLine.newQuantity);
                }
                (saleLine.item as ProductSaleLineItem).isResell = false;
            }
        }

        returnToShelfClicked(isChecked: boolean) {
            this.isResellByDefault = isChecked
            _(this.products).each(product => product.isResell = isChecked);
        }


        updateQuantity(saleLine) {
            if (saleLine && saleLine.isRefund && saleLine.finalItemPrice) {
                this.refundSubTotal -= this.getRefundPrice(saleLine, saleLine.lastNewQuantity);
                this.refundTax -= this.getRefundTax(saleLine, saleLine.lastNewQuantity);

                this.refundSubTotal += this.getRefundPrice(saleLine, saleLine.newQuantity);
                this.refundTax += this.getRefundTax(saleLine, saleLine.newQuantity);

                saleLine.lastNewQuantity = saleLine.newQuantity;
            }
        }

        getRefundTax(saleLine: Model.SaleLine, quantity: number): number {
            if (!saleLine) {
                return 0;
            }

            if (saleLine.priceIncludesTax) {
                return 0;
            }

            if (saleLine.redeemedPackageItems) {
                let tax = 0;
                for (let i = 0; i < quantity; i++) {
                    let item = saleLine.redeemedPackageItems[i];
                    for (let lineTax of item.taxes || []) {
                        tax += lineTax.finalAmount;
                    }
                    for (let charge of item.charges || []) {
                        for (let chargeTax of charge.taxes || []) {
                            tax += chargeTax.finalAmount;
                        }
                    }
                }
                return this.registerContext.normalizeDecimalPlaces(tax);
            }

            return saleLine.quantity <= 1
                ? Math.abs(saleLine.finalTax)
                : this.registerContext.normalizeDecimalPlaces(Math.abs(saleLine.originalFinalTax / saleLine.originalQuantity * quantity));

        }

        getRefundPrice(saleLine: Model.SaleLine, quantity: number): number {
            if (!saleLine) {
                return 0;
            }

            if (saleLine.redeemedPackageItems) {
                let price = 0;
                for (let i = 0; i < quantity; i++) {
                    price += this.registerContext.getRedeemedPackageItemPriceCharge(saleLine.redeemedPackageItems[i]);
                }
                return this.registerContext.normalizeDecimalPlaces(price);
            }
            return this.registerContext.normalizeDecimalPlaces((Math.abs(saleLine.finalItemPrice || 0) + Math.abs(saleLine.finalItemCharge || 0)) * quantity);
        }

        applyRefundItems() {
            for (var i = 0, len = Math.min(this.transactionSaleLines.getLength(), (this.transactionRequest.itemsPerPage * (this.transactionRequest.pageNumber + 1))); i < len; i++) {
                var item = this.transactionSaleLines.getItemAtIndex(i);
                if (item.isRefund) {
                    if (item.redeemedPackageItems) {
                        this.registerContext.addPackageRedeemedRefundSaleLine(item, item.saleType, item.newQuantity, false, this.client);
                    }
                    else {
                        // add the selected items to the smart receipt
                        item.client = this.client;

                        this.registerContext.addRefundSaleLine(item, Model.SalesTypeEnum.Product);
                    }
                }
                else {
                    //could be multiple if refund sale line got split due to having different prices 
                    // because of package charges with redemption
                    let matchedSaleLines = this.getMatchedSaleLines(item);
                    this.registerContext.sale.saleLines = _(this.registerContext.sale.saleLines).without(...matchedSaleLines);
                }
            }
            
            this.registerContext.recalculateSale();
        }

        getMatchedSaleLines(service) {
            var refundProps = { refundTransactionId: service.transactionId, refundSaleLineId: service.id, isRefund: true, refundLocationId: service.locationId };

            let matchedSaleLines = _.where(this.registerContext.sale.saleLines, refundProps);

            return matchedSaleLines;
        }

        refundTransaction() {
            this.registerContext.getSaleLinesToRefundFromTransactionId(this.scannedTransactionId).then(() => { this.scannedTransactionId = ""; });
        }

        categoryColor(bgColor, fallbackColor) {
            return { "background-color": bgColor || fallbackColor || '#a79f9f' };
        }

        canApplyRefund(): boolean {
            return true;
        }
        
        getInventoryTypeLabel(typeEnum: Model.ProductInventoryTypeEnum): string {
            return typeEnum === Model.ProductInventoryTypeEnum.Retail ? 'LABEL_RETAIL' : 'LABEL_SHOP_SUPPLY';
        }
    }
}